export const socialsData = {
    github: 'https://github.com/SoftDev0208/',
    telegram: 'https://t.me/shark0706',
    discord: 'https://discord.com/channels/@softdev0208',
    linkedin: 'https://www.linkedin.com/in/marko-m-0b8494367/'
}